"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var HomeScreen_1 = require("./HomeScreen");

exports.HomeScreen = HomeScreen_1.default;